import '../../css/ClusterSchoolBlock.css';
import BoxAddress from '../../img/box-address.svg';
import BoxDistance from '../../img/box-distance.svg';
import BoxEmail from '../../img/box-email.svg';
import BoxPhone from '../../img/box-phone.svg';

const ClusterSchoolBlock = ({clusterSchool, setBlacklistedSchools, blacklistedSchools}) => {
  return(
    <div className={`ClusterSchoolBlock`} key={clusterSchool.i}>						
      <header>
        <h1>{clusterSchool.schoolName.replaceAll("National School", "NS")}</h1>
        <h2>{clusterSchool.SETLeftOver} Hours</h2>
      </header>
      
      <section>
        <span><img src={BoxDistance} alt="distance icon" />{clusterSchool.distFromTarget}km away</span>
        <span><img src={BoxPhone} alt="phone icon" /><a href={`tel:+353${clusterSchool.phone}`}>(+353) {clusterSchool.phone}</a></span>
        <span><img src={BoxEmail} alt="email icon" /><a href={`mailto:${clusterSchool.email}`}>{clusterSchool.email}</a></span>
        <span style={{alignItems: "flex-start"}}>
          <img src={BoxAddress} alt="address icon" />
          <div className="address">
            <p>{clusterSchool.addressOne}</p>
            <p>{clusterSchool.addressTwo}</p>
            <p>{clusterSchool.addressThree}</p>
            <p>{clusterSchool.addressFour}</p>
          </div>
        </span>
        

        
        <p className="clickable remover" onClick={e => {
            setBlacklistedSchools([...blacklistedSchools, clusterSchool.schoolName])
        }}>
          <em>Remove and try again</em>
        </p>
      </section>
    </div>
  )
}


export default ClusterSchoolBlock;